import React from "react";
import { Box, Grid, IconButton, Switch, FormControlLabel } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { cloneDeep } from "lodash";
import OutcomeForm from "./OutcomeForm";
import { ActivityTypeOutcome } from "./types/types";

type Props = {
    item: ActivityTypeOutcome;
    index: number;
    onConfirmDelete: (row: ActivityTypeOutcome) => void;
    onOpenSuboutcome: (index: number) => void;
    setData: React.Dispatch<React.SetStateAction<ActivityTypeOutcome[]>>;
    setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
    data: ActivityTypeOutcome[];
};

const OutcomeRow = ({ item, index, onConfirmDelete, onOpenSuboutcome, setData, setIsDirty, data }: Props) => {
    const onUpdateInt = (index: number, prop: string, value: string) => {
        const temp = cloneDeep(data);
        temp[index][prop] = parseInt(value);
        setData(temp);
        setIsDirty(true);
    };

    const onUpdateString = (index: number, prop: string, value: string) => {
        const temp = cloneDeep(data);
        temp[index][prop] = value;
        setData(temp);
        setIsDirty(true);
    };

    const onUpdateBoolean = (index: number, prop: string, value: boolean) => {
        const temp = cloneDeep(data);
        temp[index][prop] = value;
        setData(temp);
        setIsDirty(true);
    };

    const onUpdateArray = async (index: number, prop: string, value: string[]) => {
        const temp = cloneDeep(data);
        temp[index][prop] = value;
        setData(temp);
        setIsDirty(true);
    };

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={10}>
                    <OutcomeForm
                        item={item}
                        index={index}
                        onUpdateInt={onUpdateInt}
                        onUpdateString={onUpdateString}
                        onUpdateBoolean={onUpdateBoolean}
                        onUpdateArray={onUpdateArray}
                    />
                </Grid>
                <Grid item xs={12} md={2} container spacing={1} alignItems="center">
                    <Grid item xs={6} sm={4} md={12} textAlign="center">
                        <IconButton onClick={() => onConfirmDelete(item)}>
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={6} sm={4} md={12} textAlign="center">
                        <IconButton onClick={() => onOpenSuboutcome(index)}>
                            <OpenInNewIcon />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid item xs={12} container spacing={1} alignItems="center">
                    <Grid item xs={6} sm={3} md={2} lg={1} textAlign="center">
                        <FormControlLabel
                            label="Active"
                            control={<Switch checked={item.isActive} onChange={(e) => onUpdateBoolean(index, 'isActive', e.target.checked)} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2} lg={1} textAlign="center">
                        <FormControlLabel
                            label="MI"
                            control={<Switch checked={item.isMeaningfull} onChange={(e) => onUpdateBoolean(index, 'isMeaningfull', e.target.checked)} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2} lg={1} textAlign="center">
                        <FormControlLabel
                            label="MQL"
                            control={<Switch checked={item.isMQL} onChange={(e) => onUpdateBoolean(index, 'isMQL', e.target.checked)} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2} lg={1} textAlign="center">
                        <FormControlLabel
                            label="DC"
                            control={<Switch checked={item.isDC} onChange={(e) => onUpdateBoolean(index, 'isDC', e.target.checked)} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2} lg={1} textAlign="center">
                        <FormControlLabel
                            label="Opportunity"
                            control={<Switch checked={item.isOpportunity} onChange={(e) => onUpdateBoolean(index, 'isOpportunity', e.target.checked)} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default OutcomeRow;
